export default {
  reviews: '{n} отзывов | {n} отзыв | {n} отзыва | {n} отзывов',
  offers: '{n} предложений | {n} предложение | {n} предложения | {n} предложений',
  onPhoto: 'На фото',
  more: 'Ещё',
  viewExperiences: 'Посмотреть экскурсии',
  priceFrom: 'от {price}',
  readingTime: 'Читать {n} мин',
  companyAdvantages: {
    formats: 'Форматы впечатлений для любого настроения',
    guides: 'Увлечённые гиды с живыми историями',
    nearby: 'Интересное в путешествиях и рядом с домом',
  },
} as const;
